import Papa from 'papaparse';
import { removeVoluntaryAdjustmentsAndPremiums } from "./removeVoluntaryInvoiceAdjustmentsAndPremiums.js";

/**
 * This is the primary function all numbers for display should be passed through
 * @param number
 * @param decimalPlaces
 * @param includeDollarSign
 * @returns {string|*}
 */
function formatNumber(number, decimalPlaces = 2, includeDollarSign = false) {
  if (isNaN(number)) {
    throw new Error('You must provide a number to formatNumber.');
  }
  return `${includeDollarSign ? '$' : ''}${Number(number).toFixed(decimalPlaces).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}

// TODO: remove this once everything is using formatNumber
/**
 * @param number
 * @returns {string|*}
 */
function numberWithCommas(number) {
  if (!number && number !== 0) {
    return number;
  }
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// TODO: remove this once everything is using formatNumber
/**
 * @param num
 * @param decimalPlaces
 * @private
 */
function numberWithCommasDecimals(num, decimalPlaces = 2) {
  if (isNaN(num)) {
    return num;
  }
  return Number(num).toFixed(decimalPlaces).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * @param x
 * @private
 */
function parsePhoneNumber(x) {
  return x.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}

/**
 *
 * @returns
 */
const parseFile = () => new Promise(resolve => {
  Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vTi0L6yH9Hb6eC7re-W3c3PlAFTzH0ktkmXE22iuVpyK6wvAMftYNRS0OR3W1Nuy9-_fWx5nHPtCir_/pub?output=csv", {
    download: true,
    header: true,
    complete: results => {
      resolve(results.data);
    }
  });
});

/**
 *
 */
async function fetchTelusDrugIDs() {
  let parsedData = await parseFile();
  return parsedData;
}

/**
 *
 * @param {*} string
 */
function snakeCapitalCase(string) {
  return string.replace(/\W+/g, " ").split(/ |\B(?=[A-Z])/).map(word => word.toLowerCase().charAt(0).toUpperCase() + word.slice(1)).join('_');
}

/**
 *
 * @param {*} token
 * @param {*} index
 */
function concatTokens(token, index) {
  if (index === undefined || null) {
    index = 1;
  }
  let a = token.toString() + index.toString();
  a = a.toLowerCase().replace(/[. ,:-]+/g, "-");
  return a;
}

/**
 * @param coverage
 * @param invoice
 * @returns {number}
 * @private
 */
const calculateActiveUsers = (coverage, invoice) => {
  let activeUsers = 0;
  Object.keys(invoice.currentTransactions.users).map(user => {
    if (invoice.currentTransactions.users[user].amounts[coverage].premium > 0) {
      activeUsers += 1;
    }
    return true;
  });
  return activeUsers;
};

/**
 *
 * @param {*} obj
 * @returns array of keys
 */
const sortObjByTitle = obj => Object.keys(obj).sort((a, b) => {
  // Compare the division names without spaces and all lowercase
  const aTitle = obj[a].title.toLowerCase().replace(/ /g, '');
  const bTitle = obj[b].title.toLowerCase().replace(/ /g, '');

  /*
   * First compare without numbers to see if the strings match. If they do match then sort by number
   * If the strings without numbers aren't the same then sort alphabetically
   */
  return aTitle.replace(/[0-9]/g, '') === bTitle.replace(/[0-9]/g, '') && Number(aTitle.replace(/^\D+/g, '')) - Number(bTitle.replace(/^\D+/g, '')) || aTitle.localeCompare(bTitle);
});

/**
 * @param {*} string
 * @returns
 */
const camelToNormalCase = item => (/* This series of functions takes converts the camelCase string to Normal Case */
item.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()));

/**
 * Capitalizes the first letter of a word.
 * @param {string} word - The word to be capitalized.
 * @returns {string} - The word with the first letter capitalized.
 */
export const capitalizeFirstLetter = word => {
  if (!word) {
    return null;
  }
  return word.charAt(0).toUpperCase() + word.slice(1);
};

/**
 * 
 * @param {*} str 
 * @returns 
 */
const cleanFilename = str => {
  // Remove accents and normalize the string
  str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  // Replace œ with oe
  str = str.replace(/œ/g, 'oe');

  // Replace spaces and other characters with hyphen
  str = str.replace(/[/\\?%*:|"<> ]/g, '-');

  // Replaces multiple hyphens with one hyphen
  str = str.replace(/--+/g, '-');

  // Remove extra hyphens from beginning or end of the string
  str = str.replace(/(^-+|-+$)/g, '');

  // Remove square brackets and single quotes
  str = str.replace(/[[\]']/g, '');

  // Convert to lowercase
  str = str.toLowerCase();
  return str;
};
export default {
  formatNumber,
  numberWithCommas,
  numberWithCommasDecimals,
  parsePhoneNumber,
  fetchTelusDrugIDs,
  snakeCapitalCase,
  concatTokens,
  calculateActiveUsers,
  sortObjByTitle,
  camelToNormalCase,
  capitalizeFirstLetter,
  cleanFilename,
  removeVoluntaryAdjustmentsAndPremiums
};